import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { StackItem } from "./chunk-AMDSPU3E.mjs";
import { getDividerStyles, getStackStyles, selector } from "./chunk-V4DIVZKN.mjs";

// src/stack/stack.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { getValidChildren } from "@chakra-ui/react-children-utils";
import { cloneElement, Fragment, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Stack = forwardRef(function (props, ref) {
  var isInline = props.isInline,
    directionProp = props.direction,
    align = props.align,
    justify = props.justify,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    wrap = props.wrap,
    children = props.children,
    divider = props.divider,
    className = props.className,
    shouldWrapChildren = props.shouldWrapChildren,
    rest = _objectWithoutProperties(props, _excluded);
  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var styles = useMemo(function () {
    return getStackStyles({
      direction: direction,
      spacing: spacing
    });
  }, [direction, spacing]);
  var dividerStyle = useMemo(function () {
    return getDividerStyles({
      spacing: spacing,
      direction: direction
    });
  }, [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var clones = useMemo(function () {
    var validChildren = getValidChildren(children);
    return shouldUseChildren ? validChildren : validChildren.map(function (child, index) {
      var key = typeof child.key !== "undefined" ? child.key : index;
      var isLast = index + 1 === validChildren.length;
      var wrappedChild = /* @__PURE__ */jsx(StackItem, {
        children: child
      }, key);
      var _child = shouldWrapChildren ? wrappedChild : child;
      if (!hasDivider) return _child;
      var clonedDivider = cloneElement(divider, {
        __css: dividerStyle
      });
      var _divider = isLast ? null : clonedDivider;
      return /* @__PURE__ */jsxs(Fragment, {
        children: [_child, _divider]
      }, key);
    });
  }, [divider, dividerStyle, hasDivider, shouldUseChildren, shouldWrapChildren, children]);
  var _className = cx("chakra-stack", className);
  return /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    display: "flex",
    alignItems: align,
    justifyContent: justify,
    flexDirection: styles.flexDirection,
    flexWrap: wrap,
    className: _className,
    __css: hasDivider ? {} : _defineProperty({}, selector, styles[selector])
  }, rest), {}, {
    children: clones
  }));
});
Stack.displayName = "Stack";
export { Stack };